import React from "react";
import BillingAdmin from "./pagesadmin/billing/BillingAdmin";
const HomePage = React.lazy(
  () => import("./pages/homepage/HomePageIndex"),
  "HomePage"
);
const Contact = React.lazy(
  () => import("./pages/contact/ContactIndex"),
  "Contact"
);
const Service = React.lazy(
  () => import("./pages/service/ServiceIndex"),
  "Service"
);
const FinalPreview = React.lazy(
  () => import("./pages/final-prevew/FinalPreview"),
  "NewsAdmin"
);
//ADMIN
const Home = React.lazy(() => import("./pagesadmin/Home"), "Home");
const Product = React.lazy(
  () => import("./pages/product/ProductIndex"),
  "Product"
);
const ServiceAdmin = React.lazy(
  () => import("./pagesadmin/service/ServiceIndex"),
  "ServiceAdmin"
);
const NewsAdmin = React.lazy(
  () => import("./pagesadmin/news/NewsIndex"),
  "NewsAdmin"
);
const TagsAdmin = React.lazy(
  () => import("./pagesadmin/tags/TagsIndex"),
  "NewsAdmin"
);
const NewServiceAdmin = React.lazy(
  () => import("./pagesadmin/service/NewService"),
  "NewServiceAdmin"
);
const EditServiceAdmin = React.lazy(
  () => import("./pagesadmin/service/EditService"),
  "EditServiceAdmin"
);

export const AppInternal = [
  { path: "/", exact: true, name: "Trang Chủ", component: HomePage },
  { path: "/trang-chu", name: "Trang Chủ", component: HomePage },
  { path: "/lien-he", name: "property", component: Contact },
  { path: "/dich-vu", name: "property", component: Service },
  { path: "/thanh-pham", name: "Thành Phẩm", component: FinalPreview },
  { path: "/san-pham", name: "Chi tiết sản phẩm", component: Product },
];
export const AdminInternal = [
  { path: "/admin", exact: true, name: "Home", component: Home },
  { path: "/dashboard", exact: true, name: "Home", component: Home },
  { path: "/hoa-don-dich-vu", name: "Hóa đơn dịch vụ", component: BillingAdmin },
  {
    path: "/quan-ly-dich-vu",
    exact: true,
    name: "Dịch vụ",
    component: ServiceAdmin,
  },
  {
    path: "/quan-ly-dich-vu/them",
    exact: true,
    name: "Thêm dịch vụ",
    component: NewServiceAdmin,
  },
  {
    path: "/quan-ly-dich-vu/chinh-sua/:id",
    exact: true,
    name: "Chỉnh sửa dịch vụ",
    component: EditServiceAdmin,
  },
  {
    path: "/tin-tuc",
    exact: true,
    name: "Tin tức",
    component: NewsAdmin,
  },
  {
    path: "/tags",
    exact: true,
    name: "Tags",
    component: TagsAdmin,
  },
];
